import BaseService from "./BaseService.js";

class SiteService extends BaseService {
  get() {
    return this.apiGet({
      url: '/sites',
    });
  }
  
  create(payload) {
    return this.apiPost({
      url: "/site",
      data: payload,
    });
  }
}

export default new SiteService();
